import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApprovalStatusEnum } from "src/app/services/enums/approval-status.enum";
import { HelpersService } from "@evento-ng/libs";
import { generateQR } from "src/app/shared/utils/qr-code.util";

@Component({
  selector: "app-order-item",
  templateUrl: "./order-item.component.html",
  styleUrls: ["./order-item.component.scss"],
})
export class OrderItemComponent implements OnChanges {
  @Input() order: any;
  @Input() event: any;

  ApprovalStatusEnum = ApprovalStatusEnum;

  constructor(
    public helpers: HelpersService,
    public translate: TranslateService
  ) {}

  async ngOnChanges(changes: SimpleChanges) {
    if (changes["order"]?.currentValue) {
      const qrValue = this.order?.id;

      this.order.generatedQrCode = await generateQR(qrValue);
      this.order.mutedQrCode = await generateQR(qrValue, "#cecece");
    }
  }
}
